// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pending-invitation-renderer {
  color: var(--color-content-subdued);
  font-style: italic;
}
.pending-invitation-renderer__link {
  text-decoration: underline;
  font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/user-management/management/ui/member-list-renderer/PendingInvitationRenderer.less"],"names":[],"mappings":"AAAA;EACE,mCAAA;EACA,kBAAA;AACF;AACE;EACE,0BAAA;EACA,kBAAA;AACJ","sourcesContent":[".pending-invitation-renderer {\n  color: var(--color-content-subdued);\n  font-style: italic;\n\n  &__link {\n    text-decoration: underline;\n    font-style: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
